// LoadingModal.jsx
import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";


const LoadingModal = ({ isOpen, title = 'Generating LOA Transaction' }) => {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
            {isOpen && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className="fixed inset-y-0 left-0 tracker-aware-modal-layer bg-gradient-to-br from-indigo-900/70 via-black/70 to-blue-900/70 backdrop-blur-md flex items-center justify-center z-50"
              >
                <motion.div
                  initial={{ scale: 0.95, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  exit={{ scale: 0.95, opacity: 0 }}
                  transition={{ duration: 0.3, ease: "easeOut" }}
                  className="relative bg-white/10 border border-white/20 rounded-3xl p-10 w-full max-w-sm mx-4 shadow-2xl backdrop-blur-2xl text-center"
                >
                  {/* Animated Spinner Glow */}
                  <motion.div
                    animate={{ rotate: 360 }}
                    transition={{ duration: 1.2, repeat: Infinity, ease: "linear" }}
                    className="mb-6"
                  >
                    <div className="relative w-14 h-14 mx-auto">
                      <div className="absolute inset-0 rounded-full border-4 border-indigo-500/30" />
                      <div className="absolute inset-0 rounded-full border-t-4 border-indigo-500 animate-spin" />
                    </div>
                  </motion.div>
    
                  {/* Title */}
                  <h3 className="text-xl font-semibold text-white mb-2 tracking-wide">
                    {title}
                  </h3>
    
                  {/* Subtitle */}
                  <p className="text-gray-300 text-sm mb-6">
                    Please wait while we process your request. This may take a few
                    moments.
                  </p>
    
                  {/* Progress shimmer bar */}
                  <div className="w-full bg-white/10 rounded-full h-2 overflow-hidden">
                    <motion.div
                      className="h-2 bg-gradient-to-r from-indigo-400 via-blue-500 to-indigo-400"
                      animate={{ x: ["-100%", "100%"] }}
                      transition={{
                        repeat: Infinity,
                        duration: 1.5,
                        ease: "easeInOut",
                      }}
                    />
                  </div>
    
                  {/* Optional subtle glow effect */}
                  <motion.div
                    className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-indigo-500/10 to-blue-500/10 blur-xl -z-10"
                    animate={{ opacity: [0.3, 0.6, 0.3] }}
                    transition={{
                      duration: 2,
                      repeat: Infinity,
                      ease: "easeInOut",
                    }}
                  />
                </motion.div>
              </motion.div>
            )}
          </AnimatePresence>
  );
};

export default LoadingModal;
